import React from 'react';

import moment from 'moment';

export const formFields = {


  ro: {
    key: 'ro',
    label: 'RO ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },
  roStatus: {
    key: 'roStatus',
    label: 'Status ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.', 
    valueKey: 'id',
    textKey: 'text',
  },
}

export const optionsData = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: true, type: 'number', expand: true }, 
    { id: 2, name: 'name', label: 'RO Name', sortable: true, type: 'string', component: (row) => <div title={row.name}>{row.name.length > 58 ? `${row.name.slice(0,58)} ...`: row.name }</div> },
    { id: 3, name: 'platforms', label: 'DSP Platform', sortable: false, type: 'string', component: (row) => row.platforms ? row.platforms.map((ro, i) => <span>{`${ro}`} {row.platforms.length - 1 === i ? '': <>, &nbsp;&nbsp;</>}</span>) : "-"  },
    { id: 4, name: 'primaryGoal', label: 'Primary Goal', sortable: true, type: 'number' },
    { id: 5, name: 'secondaryGoal', label: 'Secondary Goal', sortable: true, type: 'string', component: (row) => row.secondaryGoal ? row.secondaryGoal : "-" },
    { id: 6, name: 'lastUpdate', label: 'Last Update', sortable: true, type: 'string', component: (row) => row.lastUpdate != undefined ? moment(row.lastUpdate).format("YYYY-MM-DD") : "-" },
    { id: 7, name: 'status', label: 'Status', sortable: false, type: 'string', component: (row) => row.status === 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
    // {k
    //   id: 8, name: 'budgetName', label: 'Options', sortable: true, type: 'string', component: (row) => <div className='text-left'><i className='mdi mdi-pencil'></i>
    //   </div>
    // },
    // <div className='text-left'>{row.platforms.map((e, index) => e.platform)}</div>
    // { id: 6, name: 'startDate', label: 'Start Date', sortable: true, type: 'date', component: (row) => moment(row.startDate).format('DD-MMM-YY') },
    // // { id: 7, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => moment(row.endDate).format('DD-MMM-YY') },
    // { id: 7, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => row.endDate ? moment(row.endDate).format('DD-MMM-YY') : '' },
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  },
  ],
  // recActive: true,
  // status: {
  //   key: 'rec_active',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const status = [
  {}
]